import { render, staticRenderFns } from "./IndustryChat.vue?vue&type=template&id=0ac2667e&scoped=true"
import script from "./IndustryChat.vue?vue&type=script&lang=js"
export * from "./IndustryChat.vue?vue&type=script&lang=js"
import style0 from "./IndustryChat.vue?vue&type=style&index=0&id=0ac2667e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2667e",
  null
  
)

export default component.exports